<template>
    <div class="footer-box">
        <div class="footer-content">
          <img src="https://static.hzjly.cn//authorizationserver/img/logo_subweb.png"/>
          <div class="footer-p">
            <p>
              联系地址：杭州经济技术开发区6号大街452号高科技企业孵化园区3幢5层
            </p>
            <p>
              版权所有 &nbsp;&nbsp; <a href="https://www.hzjly.com/" target="_blank" >杭州路格科技有限公司</a>
              <a href="https://beian.miit.gov.cn/" target="_blank" >浙ICP备13032066号-2</a>

            </p>
          </div>
        </div>
    </div>


</template>

<script>
    export default {
        name: "vfooter",
        data() {
            return {}
        },
        mounted() {

        },
        methods: {}
    }
</script>

<style scoped>
 .footer-box{
   border-top: 1px #d2d2d2 solid;
   padding: 20px 0;
   height: 60px;
   background: #f2f2f2;
   width: 100%;
 }
 .footer-content {
   display: flex;
   align-items: center;
   justify-content: center;
 }
 .footer-p {
   line-height:30px;
   margin-left: 30px;
   display: flex;
   flex-direction: column;
   text-align: left;
 }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue